import { instance } from './index'

// fetch 
function fetchData (url, data, config) {
  return instance.get(url, {params: data}, config)
}

// post
function postData (url, data, config) {
  return instance.post(url, data, config)
}

// put
function putData (url, data) {
  return instance.put(url, data) 
}

// delete 
function deleteData (url) {
  return instance.delete(url)
}

export { fetchData, postData, putData, deleteData }